import { selectAnaliticsTrackEventFunc, selectPreviewSpellingStatus } from "@app/routes/activities/spelling/store/spellingSlice";

const getSpellingDefaultProperties = (boardId, state) => {
  const spellingState = selectPreviewSpellingStatus(state, boardId) || {};
  return {
    activity_id: spellingState?.gameId,
    task_id: spellingState?.measurementUUID,
    total_words: spellingState?.totalWords,
  };
};

export const trackSpellingEvent = (eventName, state, boardId, additionalParams = {}) => {
  selectAnaliticsTrackEventFunc(state, boardId)?.(eventName, { ...additionalParams, ...getSpellingDefaultProperties(boardId, state) });
};

